import * as React from "react";
import { forwardRef } from "react";
const SvgCircleCheckmark2 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, rx: 12, fill: "#36B37E" }), /* @__PURE__ */ React.createElement("path", { d: "M10.0001 14.7799L7.2201 11.9999L6.27344 12.9399L10.0001 16.6666L18.0001 8.66656L17.0601 7.72656L10.0001 14.7799Z", fill: "white" }));
const ForwardRef = forwardRef(SvgCircleCheckmark2);
export default ForwardRef;
